import {
  Box,
  CircularProgress,
  styled,
  TextField,
  Typography,
} from "@mui/material"
import { WhiteCard } from "../../components/styled"

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
})

export const Description = styled(Typography)({
  textAlign: "center",
  marginBottom: 20,
})

export const SearchInput = styled(TextField)({
  "& .MuiInputBase-root": {
    borderRadius: 500,
  },
  "& input": {
    padding: "7px 18px 7px 0",
    fontSize: 16,
  },
  marginBottom: 30,
})

export const BanksContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 20,
  overflow: "scroll",
})

export const Loading = styled(CircularProgress)({
  margin: "auto",
  color: "#FFE532",
})

export const BankCard = styled(WhiteCard)({
  width: "100%",
  boxSizing: "border-box",
  margin: "30px 0",
  display: "flex",
  flexDirection: "column",
})

export const IconContainer = styled(Box)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "auto",
})
